export {PopoverDirective} from './popover.directive';
export {PopoverModule} from './popover.module';
export {PopoverConfig} from './popover-config';
export {PopoverContainerComponent} from './popover-container.component';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./~/ng2-bootstrap/src/popover/index.ts